import { render } from "./ReportsGroupedWord.vue?vue&type=template&id=36971b06&scoped=true"
import script from "./ReportsGroupedWord.vue?vue&type=script&lang=js"
export * from "./ReportsGroupedWord.vue?vue&type=script&lang=js"

import "./ReportsGroupedWord.vue?vue&type=style&index=0&id=36971b06&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36971b06"]])

export default __exports__